import { SessionStore } from './sessionStore';
import { authService } from '../data-services';

export const sessionStore = new SessionStore(authService);

export const GlobalStore = {
    session: sessionStore,
};
